module.exports = __webpack_public_path__ + "static/partner-21ebc2613b1f5195144f0966fc8e3f79.png";